export default __webpack_public_path__ + "static/media/kitchen3-before3-480w.39ea3ae3.png";